<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-header text-center">
        <p class="h4 float-left">Lista Almacenes</p>
        <a (click)="createWarehouse()" class="btn btn-success float-right">
          Registrar entrada</a
        >
      </div>
      <div class="card-body">
        <input
          class="form-control"
          #searchTerm
          (keyup)="search(searchTerm.value)"
          placeholder="Buscando productos..."
        />
        <div *ngIf="almacen && !warehouseService.isLoading">
          <table
            class="table table-condensed table-hover  table-sm table-md table-bordered table-responsive-sm"
          >
            <thead>
              <tr class="text-center">
                <th>#</th>
                <th>Producto Nombre</th>
                <th>Unidad</th>
                <th>Cant.</th>
                <th>P. Compra</th>
                <th>F. Ingreso</th>
                <th>Nro.</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody *ngFor="let warehouse of almacen.data; let i = index">
              <tr class="text-right"  >
                <th scope="row">{{ i + 1 + (almacen.current_page - 1) * almacen.per_page }}</th>
                <td class="text-left">{{ warehouse.nombre_producto }}</td>
                <td class="text-center">{{ warehouse.unidad }}</td>
                <td  >{{ warehouse.cantidad }}</td>
                <td   >{{ warehouse.precio_compra | number: '1.2-2' }}</td>
                <td class="text-center">
                  {{ warehouse.fecha_ingreso | date: 'dd/MM/yyyy' }}
                </td>
                <td>{{ warehouse.nro_comprobante }}</td>

                <td class="text-center">
                  <button
                    type="button"
                    (click)="editModal(warehouse.almacen_id)"
                    class="btn btn-default "
                  >
                    <i
                      class="fa fa-pencil-square-o text-info"
                      style="font-size: 30px"
                    ></i>
                  </button>

                  <button
                    type="button" 
                    (click)="eliminar(warehouse.almacen_id)" 

                  >
                    <i class="fa fa-trash" style=" font-size: 20px"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Mostrando Productos {{ almacen.from }} a {{ almacen.to }} de
            {{ almacen.total }}
          </p>
          <p>Página {{ almacen.current_page }} de {{ almacen.last_page }}</p>
          <input type="number" style="width: 50px;"
          [(ngModel)]="paginanum" name="home" required min="0" step="1">
          <button (click)="searchPage(paginanum)" >
           ir
         </button>
    <br>
          <button (click)="prevPage()" [disabled]="!almacen.prev_page_url">
            Anterior
          </button>
          <button (click)="nextPage()" [disabled]="!almacen.next_page_url">
            Siguiente
          </button>
        </div>
      </div>
      <p *ngIf="warehouseService.isLoading">Cargando...</p>
    </div>
  </div>
</div>
